export default {
    importer: {
        drophere : "Datei hier ablegen",
        search   : "Suchen ...",
        selectall: "alle auswählen",
        doimport : "importieren",
        newimport: "neuer Import",
        loading  : "Anlagen werden geladen ...",

        process: {
            success: "Die Datei wurde erfolgreich importiert!",
            error: "Beim Importieren der Datei ist ein Fehler aufgetreten."
        },

        filter: {
            errors: {
                off: "Vollständige Datei",
                on : "Nur Fehlerhafte Zeilen"
            },
            unit: {
                errors: {
                    off: "Alle Anlagen",
                    on : "Nur Fehlerhafte Anlagen"
                },
            }
        },

        entity: {
            lim: {
                contract: "Vertrag",
                beneficiary: "Leistungsempfänger",
                invoice: {
                    recipient: "Rechnungsempfänger"
                }
            },

            mnt: {
                contract: "Vertrag",
            },

            emc: {
                contract: "Vertrag",
            },

            zus: {
                contract: "Vertrag",
            },

            contact: "Kontakte",
            beneficiary: "Leistungsempfänger",
            contract   : "Vertrag",
            invoiceRecipient: "Rechnugsempfänger"
        },

        header: {
            customer  : {
                id: "Kunde",
            },
            unit: {
                id          : "HC-ID",
                no          : "Fabriknummer",
                external    : "Kunden ID",
                country     : "Land",
                zip         : "PLZ",
                city        : "Stadt",
                street      : "Straße",
                manufacturer: "Hersteller",
                branch      : "Bereich",
                ve          : "VE",
                ve2         : "VE2",
                ve3         : "VE3",
                type        : "Anlagenart",
                notice      : "Notiz",
                eq: {
                    zus: "Equipment (ZÜS)",
                    mnt: "Equipment (WN)"
                },

                customer: {
                    notvalid: "HC-ID nicht gültig"
                }


            },
            company: {
                name: "Unternehmen"
            },
            role: {
                name: "Rolle"
            },

            contact: {
                group     : "Gruppe",
                id        : "ID",
                salutation: "Anrede",
                firstname : "Vorname",
                name      : "Nachname",
                email     : "Email",
                phone     : "Telefon",
                mobile    : "Mobile"
            },
            lim: {
                contract: "Vertrag",
                start   : "Vertragsbeginn",
                end     : "Vertragsende",
                type    : "Vertragsart",
                costs   : {
                    lgs : "LGS Kosten",
                    lm  : "LM Kosten"
                },
                beneficiary: {
                    name: "Leistungsempfänger",
                    nameadd: "Namenszusatz",
                    country: "Land",
                    zip: "PLZ",
                    city: "Stadt",
                    street: "Straße",
                    use: {
                        lm: "Liftmanagement",
                        lim: "Ereignisse"
                    }
                },
                invoice: {
                    recipient: {
                        name: "Rechnungsempfänger",
                        nameadd: "Namenszusatz",
                        country: "Land",
                        zip: "PLZ",
                        city: "Stadt",
                        street: "Straße",
                        use: {
                            lm: "Liftmanagement",
                            lim: "Ereignisse"
                        },
                        debitor: "Debitor",
                    }
                }
            },

            mnt: {
                contract: "Vertrag",
                company : "Wartungsnehmer",
                start   : "Vertragsbeginn",
                end     : "Vertragsende",
                type    : "Wartungsart",
                count   : "Wartungen p.Jahr",
                costs   : "Wartungskosten p.ahr",
                incl: {
                    emc             : "inkl. Notruf",
                    rent            : "inkl. Miete",
                    standby         : "inkl. Bereitschaft",
                    teleservice     : "inkl. Teleservice",
                    inspection      : "inkl. ZÜS Prüfungen",
                    phone           : "inkl. Telefon",
                    guard           : "inkl. Aufzugswärter",
                    smokeextraction : "inkl. Schachtentrauchung",
                    inspectionAddOns: "inkl. Monteurgestellung",
                    incidents       : "inkl. Störungsbeseitigung"
                }
            },

            emc: {
                contract     : "Vertrag",
                company      : "Notrufnehmer",
                costs        : "Notrufkosten p.Jahr",
                deviceRentBuy: "Notrufgerät",
                start        : "Vertragsbeginn",
                end          : "Vertragsende",
                rent         : "Betrag Miete",
                standby      : "Bereitschaft p. Jahr",
                phone        : "Telefonkosten",
                guard        : "Aufzugswärter"
            },

            zus: {
                contract: "Vertrag",
                company : "ZÜS",
                start   : "Vertragsbeginn",
                end     : "Vertragsende",
                costs  : {
                    main        : "Hauptprüfung",
                    intermediate: "Zwischenprüfung",
                    change      : "Prüfung nach Änderung",
                    review      : "Prüfung nach Mängelbeseitigung"
                }
            },

            dls: {
                amount: {
                    gross: "VK",
                    net  : "EK"
                }
            },

            beneficiary: {
                name   : "RE Name",
                nameadd: "RE Namenszusatz",
                country: "Land",
                zip    : "PLZ",
                city   : "Stadt",
                street : "Straße",
                use: {
                    lm : "LM Rechnung",
                    lim: "Ereignisse"
                }
            },

            invoice: {
                frequency: "Frequenz",
                target   : "Stichtag",
                recipient: {
                    name: "LE Name",
                    nameadd: "LE Namenszusatz",
                    country: "Land",
                    zip    : "PLZ",
                    city   : "Stadt",
                    street : "Straße",
                    debitor: "Debitor",
                    use: {
                        lm : "LM Rechnung",
                        lim: "Ereignisse"
                    }
                },
            },

            toc: {
                deadline: "Kündigungsfrist",
                renewal : "Automatische Verlängerung"
            }
        },

        input: {
            title: "Eingabedatei",

        },

        output: {
            title: "Ergebnis",
        },

        error: {
            customer: {
                unknown: "Kunde ist ungültig",
            },

            country: {
                unknown: "Land ist ungültig",
            },

            value: {
                required: "Wert muss angegeben werden!",
                format: {
                    phone  : "Telefon nicht korrekt",
                    email  : "Email nicht korrekt",
                    date   : "Datum nicht korrekt",
                    boolean: "Wert nicht korrekt",
                    money  : "Betrag nicht korrekt",
                    integer: "Wert nicht korrekt"
                }
            },

            company: {
                unknown: "Unternehmen nicht gefunden",
                notUnique: "Nicht eindeutig",
                role: {
                    manufacturer: "Hersteller erforderlich",
                    emc         : "Notrufnehmer erforderlich",
                    mnt         : "Wartungsnehmer erforderlich",
                    zus         : "ZÜS erforderlich",
                },
                fits: {
                    invalid: {
                        zus: "Kein Vertrag mit dieser ZÜS",
                    },
                    noContract: {
                        zus: "Es gibt keinen ZÜS Vertrag",
                    }
                }
            },


            unit: {
                notFound: "HC-ID ungültig",
                no: {
                    unknown: "Fabrik-Nr. ungültig",
                    notUnique: "Fabriknummer nicht eindeutig",
                    noMatch : "Fabriknummer passt nicht zur HC-ID"
                },

            }  ,

            contact: {
                notUnique: "Kontakt doppelt",
                id: {
                    notFound : "ID nicht gültig",
                    name    : "Name passt nicht",
                    email   : "Email passt nicht",
                    customer: "Kontakt nicht beim Kunden",
                    company : "Unterschiedliche Unternehmen",
                    role    : "Rolle passt nicht"
                },
                role: {
                    unknown : "Rolle ungültig",
                    required: "Die Rolle muss abgegeben werden",
                    nomatch : "Rolle passt nicht zum Ansprechpartner",
                },
                salutation: {
                    unknown: "Anrede ungültig"
                }
            },

            contract: {
                none   : "Kein Vertrag",

                lim: {
                    type: {
                        unknown: "Ungültiger Vertrag"
                    }
                },
                invoice: {
                    frequency: {
                        unknown: "Zahlungsfrequenz nicht gültig",
                        required: "Zahlungsfrequenz fehlt"
                    },
                    target: {
                        required: "Zahlungsziel fehlt",
                        day     : "Tag fehlt",
                        month   : "Monat fehlt"
                    },
                    toc: {
                        type: "Ungültige Kündigungsfrist",
                        duration: "Ungültige Kündigungsfrist"
                    },
                    renewal: {
                        invalid: "Verlängerung ungültig"
                    }
                },

                mnt: {
                    notUnique: "Wartungsvertrag nicht eindeutig",
                },

                emc: {
                    notUnique: "Notrufvertrag nicht eindeutig",
                    gadget: {
                        unknown: "Wert nicht gültig",
                    }
                }
            }
        },


        //---------------
        message: {
            yesno: {
                invalid: "ungültig"
            },
            customer: {
                empty  : "Kunde erforderlich",
                unknown: "ungültig",
                invalid: "ungültig",
                required: "ungültig",
            },

            unit: {
                hcid: {
                    unknown  : "ungültig",
                    notunique: "HC-ID doppelt"
                },
                elevatorno: {
                    missing  : "Fabrik-Nr. erforderlich",
                    exists   : "Fabrik-Nr. existiert",
                    notunique: "Fabrik-Nr. doppelt",
                    unknown  : "Fabrik-Nr. unbekannt"
                },
                externalId: {
                    exists   : "Kunden-ID exisiert",
                    notunique: "Kunden-ID doppelt"
                }
            },

            manufacturer: {
                unknown: "ungültig",
                required: "ungültig",
                notunique: "Hersteller nicht eindeutig"
            },

            contract: {
                type: {
                    notfound: "ungültig",
                    required: "ungültig",
                },
            },

            contact: {
                role: {
                    unknown: "Ungültige Rolle",
                },

                salutation: {
                    unknown: "Ungültige Anrede",
                },

                company: {
                    unknown: "Ungültige Anrede",
                    invalid: "Ungültiges Unternehmen",
                    notunique: "Unternehmen nicht eindeutig",
                    nocontactrole: "Rolle des Kontakts ist ungültig"
                },

                name: {
                    required: "Name erforderlich"
                },

                id: {
                    invalid : "Ungültige Kontakt ID",
                    notfound: "ID nicht gefunden"
                },

                phone: {
                    notunique: "Telefon nicht eindeutig"
                }
            },

            type: {
                unknown: "ungültig"
            },

            country: {
                unknown: "ungültig"
            }
        }
    },
}

